import React from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import * as actions from '../actions';
import EndorsingOffices from '../components/endorsingOffices/EndorsingOffices';

function EndorsingOfficeModal({ data, handleEndorsingOffice }) {
  return (
    <Modal.Body>
      <div>
        <EndorsingOffices
          data={data}
          handleEndorsingOffice={handleEndorsingOffice}
        />
      </div>
    </Modal.Body>
  );
}

EndorsingOfficeModal.defaultProps = {
  handleEndorsingOffice: () => {},
};

EndorsingOfficeModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  handleEndorsingOffice: PropTypes.instanceOf(Function),
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(EndorsingOfficeModal);
